<template>
  <b-modal
    id="annonce-pro-modal"
    class="annonce-pro-full-screen-modal"
    ref="modal"
    @ok="handleOk"
    centered
    no-close-on-esc
    no-close-on-backdrop
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div class="annonce-pro-modal-close-container">
        <i class="ph-custom ph-x-bold annonce-pro-modal-close-btn" @click="close"/>
      </div>
    </template>

    <div>
      <div class="annonce-pro-modal-warning-container">
        <i class="ph-warning-fill annonce-pro-modal-warning-icon"/>
      </div>

      <p class="annonce-pro-modal-title">{{ $t('annonce.modal.pro.title') }}</p>

      <p class="annonce-pro-modal-text mt-2" v-html="$t('annonce.modal.pro.text.1')"></p>
      <p class="annonce-pro-modal-text" v-html="$t('annonce.modal.pro.text.2', { proUrlLink : proUrlLink })"></p>
    </div>

    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button  class="w-100" variant="primary"  @click="handleOk($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('annonce.modal.pro.button.ok')}}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";

export default {

  name: 'AnnonceProModal',

  emits: ['okProModal'],

  data: function () {
    return {
      proUrlLink: "",
    }
  },

  mounted () {
    this.fetchLinks()
  },

  methods: {

    async fetchLinks() {
      const response = await api.get('/home/getEnvironmentLinks');
      this.proUrlLink = response.data.proUrlLink
    },

    async handleOk(e) {
      e.preventDefault()
      this.$emit('okProModal')
      this.$bvModal.hide('annonce-pro-modal')
    },

  },
};
</script>

<!-- not scoped car modal --><style>

#annonce-pro-modal .modal-header,
#annonce-pro-modal .modal-content,
#annonce-pro-modal .modal-body,
#annonce-pro-modal .modal-footer{
  background-color: var(--main-black-dark);
}

#annonce-pro-modal .modal-header {
  padding: 0px;
}

#annonce-pro-modal .annonce-pro-modal-close-container {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1;
}
#annonce-pro-modal .annonce-pro-modal-close-btn {
  cursor: pointer;
  font-size: 30px;
  color: var(--main-grey-medium);
}
#annonce-pro-modal .annonce-pro-modal-close-btn:hover {
  cursor: pointer;
  color: var(--main-grey-dark);
}

#annonce-pro-modal .annonce-pro-modal-warning-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}
#annonce-pro-modal .annonce-pro-modal-warning-icon {
  font-size: 70px;
  color: var(--main-yellow-darker);
}


#annonce-pro-modal .annonce-pro-modal-title {
  font-size: 24px;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
}
#annonce-pro-modal .annonce-pro-modal-text {
  color: var(--main-grey-medium);
}



#annonce-pro-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.annonce-pro-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.annonce-pro-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #annonce-pro-modal .modal-content {
    display: flex;
    overflow: auto;
  }
  #annonce-pro-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-pro-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #annonce-pro-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #annonce-pro-modal .modal-header {
    padding-top: 0px;
  }
  #annonce-pro-modal .modal-content {
    margin: 8px;
  }
}

@media (max-height: 852px) {
  #annonce-pro-modal .modal-content {
    overflow: auto;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/annonce/AnnonceProModal.vue